import { cnpj, cpf } from 'cpf-cnpj-validator';

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }
  if (values.checkingAccount) {
    if (!values.bank) {
      errors.bank = 'Esse campo não pode ficar vazio';
    }
    if (!values.agency) {
      errors.agency = 'Esse campo não pode ficar vazio';
    }
    if (!values.accountNumber) {
      errors.accountNumber = 'Esse campo não pode ficar vazio';
    }
    if (values.ownerIdentifier) {
      if (values.ownerIdentifier.length === 14) {
        const cnpjIsValid = cnpj.isValid(values.ownerIdentifier);
        if (!cnpjIsValid) {
          errors.ownerIdentifier = 'Informe um CNPJ válido!';
        }
      }
      if (values.ownerIdentifier.length === 11) {
        const cpfIsValid = cpf.isValid(values.ownerIdentifier);
        if (!cpfIsValid) {
          errors.ownerIdentifier = 'Informe um CPF válido!';
        }
      }
    } else {
      errors.ownerIdentifier = 'Esse campo não pode ficar vazio';
    }
  }
  if (values.smartpay) {
    if (!values.companyName) {
      errors.companyName = 'Esse campo não pode ficar vazio';
    }
    if (values.cnpj) {
      const cnpjIsValid = cnpj.isValid(values.cnpj);
      if (!cnpjIsValid) {
        errors.cnpj = 'Informe um CNPJ válido!';
      }
    } else {
      errors.cnpj = 'Esse campo não pode ficar vazio';
    }
    if (!values.respName) {
      errors.respName = 'Esse campo não pode ficar vazio';
    }
    if (values.respCpf) {
      const cpfIsValid = cpf.isValid(values.respCpf);
      if (!cpfIsValid) {
        errors.respCpf = 'Informe um CPF válido!';
      }
    } else {
      errors.respCpf = 'Esse campo não pode ficar vazio';
    }
    if (!values.bank) {
      errors.bank = 'Esse campo não pode ficar vazio';
    }
    if (!values.bankAgency) {
      errors.bankAgency = 'Esse campo não pode ficar vazio';
    }
    if (!values.banckCc) {
      errors.banckCc = 'Esse campo não pode ficar vazio';
    }
    if (!values.type) {
      errors.type = 'Esse campo não pode ficar vazio';
    }
    if (values.zipCode) {
      if (values.zipCode.trim().length < 8) {
        errors.zipCode = 'CEP Inválido';
      }
    } else {
      errors.zipCode = 'CEP Inválido';
    }
    if (!values.address) {
      errors.address = 'Esse campo não pode ficar vazio';
    }
    if (!values.addressNumber) {
      errors.addressNumber = 'Esse campo não pode ficar vazio';
    }
    if (!values.state) {
      errors.state = 'Esse campo não pode ficar vazio';
    }
    if (!values.phone) {
      errors.phone = 'Esse campo não pode ficar vazio';
    }
    if (
      values.interestRateForDelay < 0 ||
      values.interestRateForDelay > 99 ||
      !values.interestRateForDelay
    ) {
      errors.interestRateForDelay = 'Informe um valor entre 0 e 99';
    }
    if (!Number.isInteger(values.interestRateForDelay)) {
      if (values.interestRateForDelay.includes('.')) {
        errors.interestRateForDelay = 'Informe um valor inteiro';
      }
    }
    if (!values.autoWithDraw) {
      if (
        parseInt(values.numberWithdrawals, 10) < '0' ||
        parseInt(values.numberWithdrawals, 10) > '99' ||
        !values.numberWithdrawals
      ) {
        errors.numberWithdrawals = 'Informe um valor entre 0 e 99';
      }
      if (!Number.isInteger(values.numberWithdrawals)) {
        if (values.numberWithdrawals.includes('.')) {
          errors.numberWithdrawals = 'Informe um valor inteiro';
        }
      }
      if (
        parseInt(values.bankSlipCommission, 10) < 0 ||
        parseInt(values.bankSlipCommission, 10) > 999 ||
        !values.bankSlipCommission
      ) {
        errors.bankSlipCommission = 'Informe um valor entre 0 e 999';
      }
      if (!Number.isInteger(values.bankSlipCommission)) {
        if (values.bankSlipCommission.includes('.')) {
          errors.bankSlipCommission = 'Informe um valor inteiro';
        }
      }
    }
  }
  return errors;
};

export default validate;
